import { render, staticRenderFns } from "./SiteRequestThankYou.vue?vue&type=template&id=13bcb526&"
import script from "./SiteRequestThankYou.vue?vue&type=script&lang=js&"
export * from "./SiteRequestThankYou.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports